export let logindata = [
    {
        "placeholder": "Enter Email",
        "formname": "email",
        "type": "email",
        "error": false,
        "errormsg": ""
    },
    {
        "placeholder": "Enter Password",
        "formname": "password",
        "type": "password",
        "error": false,
        "errormsg": ""
    }
]

export let regdata = [

    {
        "placeholder": "Enter Name",
        "formname": "name",
        "type": "text",
        "error": false,
        "errormsg": ""
    },

    {
        "placeholder": "Enter Email",
        "formname": "email",
        "type": "email",
        "error": false,
        "errormsg": ""
    },

    {
        "placeholder": "Enter Phone Number",
        "formname": "phone",
        "type": "number",
        "error": false,
        "errormsg": ""
    },

    {
        "placeholder": "Enter Password",
        "formname": "password",
        "type": "password",
        "error": false,
        "errormsg": ""
    },

    {
        "placeholder": "Confirm Password",
        "formname": "confirmpassword",
        "type": "password",
        "error": false,
        "errormsg": ""
    },
    {
        "placeholder": "Select Role",
        "value": null,
        "type": "dropdown",
        "error": false,
        "errormsg": "",
        "options": [
        {
            "value": "user",
            "placeholder": "User"
        }]
        

    }
]